import { useEffect, useState, useCallback } from "react";
import { Link } from "react-router-dom";
import { Search, Phone } from "lucide-react";
import { api, formatPrice, STATUS_LABELS } from "@/lib/api";

const STATUSES = ["all", "nouvelle", "a_rappeler", "chauffeur_assigne", "en_route", "sur_place", "vehicule_charge", "termine", "paye", "annule"];

export default function AdminRequests() {
  const [rows, setRows] = useState([]);
  const [q, setQ] = useState("");
  const [status, setStatus] = useState("all");

  const load = useCallback(() => {
    api.get("/admin/requests", { params: { q: q || undefined, status } }).then((r) => setRows(r.data)).catch(() => {});
  }, [q, status]);

  useEffect(() => { const t = setTimeout(load, 200); return () => clearTimeout(t); }, [load]);

  return (
    <div>
      <div className="font-heading text-3xl lg:text-4xl font-black uppercase tracking-tight">Demandes</div>
      <div className="h-1 w-16 bg-brand mt-2 mb-6" />

      <div className="flex flex-col md:flex-row md:items-center gap-3 mb-4">
        <div className="relative flex-1 max-w-md">
          <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-zinc-500" />
          <input className="w-full h-11 pl-10 pr-4 bg-ink-900 border border-ink-700 focus:border-brand text-white outline-none" placeholder="N°, nom, téléphone, plaque..." value={q} onChange={(e) => setQ(e.target.value)} data-testid="admin-requests-search" />
        </div>
        <div className="flex flex-wrap gap-1">
          {STATUSES.map((s) => (
            <button key={s} onClick={() => setStatus(s)} className={`px-3 py-1.5 text-xs uppercase tracking-wider font-bold ${status === s ? "bg-brand text-white" : "bg-ink-800 text-zinc-400 hover:text-white"}`} data-testid={`filter-${s}`}>
              {s === "all" ? "Tous" : (STATUS_LABELS[s] || s)}
            </button>
          ))}
        </div>
      </div>

      <div className="bg-ink-900 border border-ink-700 overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-ink-800 text-zinc-400 uppercase text-xs tracking-wider">
            <tr>
              <th className="text-left px-4 py-3">N°</th>
              <th className="text-left px-4 py-3">Client</th>
              <th className="text-left px-4 py-3">Service</th>
              <th className="text-left px-4 py-3">Adresse</th>
              <th className="text-left px-4 py-3">Statut</th>
              <th className="text-right px-4 py-3">Estimé</th>
              <th className="text-right px-4 py-3">Final</th>
              <th></th>
            </tr>
          </thead>
          <tbody className="divide-y divide-ink-700">
            {rows.map((r) => (
              <tr key={r.id} className="hover:bg-ink-800" data-testid={`row-${r.request_number}`}>
                <td className="px-4 py-3"><Link to={`/admin/demandes/${r.id}`} className="text-brand font-bold">{r.request_number}</Link></td>
                <td className="px-4 py-3"><div className="font-semibold">{r.customer_name}</div><div className="text-xs text-zinc-500"><a href={`tel:${r.customer_phone}`} className="inline-flex items-center gap-1"><Phone size={10} />{r.customer_phone}</a></div></td>
                <td className="px-4 py-3">{r.service_type}</td>
                <td className="px-4 py-3 max-w-[220px] truncate">{r.pickup_address}</td>
                <td className="px-4 py-3"><span className="bg-ink-800 border border-ink-700 px-2 py-1 text-xs">{STATUS_LABELS[r.status] || r.status}</span></td>
                <td className="px-4 py-3 text-right">{formatPrice(r.estimated_price)}</td>
                <td className="px-4 py-3 text-right">{formatPrice(r.final_price)}</td>
                <td className="px-4 py-3"><Link to={`/admin/demandes/${r.id}`} className="text-zinc-400 hover:text-brand text-xs">Voir →</Link></td>
              </tr>
            ))}
            {!rows.length && <tr><td colSpan={8} className="text-center py-8 text-zinc-500">Aucune demande</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
